// extracted by mini-css-extract-plugin
export default {"whitelabel":"whitelabelcydJw"};